export type PaginationRangeItem = number | 'ellipsis'

export const getPaginationRange = (
  currentPage: number,
  totalPages: number
): PaginationRangeItem[] => {
  if (totalPages <= 1) {
    return totalPages === 1 ? [1] : []
  }

  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1)
  }

  const pages: PaginationRangeItem[] = [1]
  const start = Math.max(2, currentPage - 1)
  const end = Math.min(totalPages - 1, currentPage + 1)

  if (start > 2) {
    pages.push('ellipsis')
  } else {
    for (let page = 2; page < start; page++) {
      pages.push(page)
    }
  }

  for (let page = start; page <= end; page++) {
    pages.push(page)
  }

  if (end < totalPages - 1) {
    pages.push('ellipsis')
  } else {
    for (let page = end + 1; page < totalPages; page++) {
      pages.push(page)
    }
  }

  pages.push(totalPages)

  return pages
}
